import { store } from "../store";
import { setEnhancedConditionDocumentsListByCategories } from "../../features/fetch-enhanced-conditions-documents-list-by-category/fetchEnhancedConditionsDocumentsListByCategory";

export const getEnhancedConditionsDocumentsListByCategory = async ({
	loanGuid,
	conditionType,
	apiRequest,
	handleErrorModal,
	handleCloseModal,
}) => {
	try {
		const enhancedConditionsValue = await apiRequest({
			loanGuid,
			conditionType,
		}).unwrap();

		store.dispatch(
			setEnhancedConditionDocumentsListByCategories(enhancedConditionsValue?.data)
		);

		handleCloseModal?.();
		return enhancedConditionsValue;
	} catch (err) {
		handleErrorModal(err);
	}
};
